import { dataReportTrendSwitchSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconReportTrendSwitchSolid = /*#__PURE__*/createIcon(dataReportTrendSwitchSolid)
export default IconReportTrendSwitchSolid
